import { Button } from '@consta/uikit/Button'
import { Checkbox } from '@consta/uikit/Checkbox'
import { isMultipartSetupOfSpecificType, setUpdateIfExists, useAppDispatch } from '@core/core/store'
import type { MarkerSetupType } from '@core/core/types'
import type { FC } from 'react'

import type { StepButtonsProps } from '../types'

export const StepMarkerButtons: FC<StepButtonsProps> = ({
  onReturnDefaultValues,
  onSetupNextStepClick,
  onMappingPrevStepClick,
  onLoadingPrevStepClick,
  uploadedFile,
  activeStep,
  onAddFilesToProject,
}) => {
  const dispatch = useAppDispatch()

  if (
    !isMultipartSetupOfSpecificType<MarkerSetupType>(
      uploadedFile,
      uploadedFile?.setupContent,
      'marker',
    )
  ) {
    return null
  }

  const settings = uploadedFile.setupContent
  const isAnyMapped = uploadedFile.mappedEntities?.find(value => value.mappedTo !== undefined)

  switch (activeStep) {
    case 'setup': {
      return (
        <>
          <Button
            size="s"
            view="ghost"
            label="Сбросить настройки"
            onClick={onReturnDefaultValues}
          />
          <Button
            data-testid="nextStepBtn"
            size="s"
            label="Далее"
            disabled={!settings.isValid}
            onClick={onSetupNextStepClick}
          />
        </>
      )
    }
    case 'mapping': {
      return (
        <>
          <Checkbox
            label="Заменить существующие маркеры"
            checked={uploadedFile.updateIfExists}
            onChange={event => {
              dispatch(setUpdateIfExists(uploadedFile.fileId, event.target.checked))
            }}
          />
          <Button size="s" label="Назад" view="ghost" onClick={onMappingPrevStepClick} />
          <Button
            disabled={!isAnyMapped}
            size="s"
            data-testid="addToProjectBtn"
            label="Добавить в проект"
            onClick={onAddFilesToProject}
          />
        </>
      )
    }
    case 'loading': {
      return <Button size="s" label="Назад" onClick={onLoadingPrevStepClick} />
    }
    default: {
      return null
    }
  }
}
